export const ADDRESS_MAP_BLOCKTYPE = 'address';
export const DESTINATION_MAP_BLOCKTYPE = 'destination';
export const DEFAULT_MAP_BLOCKTYPE = DESTINATION_MAP_BLOCKTYPE;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/address/constants.js